import { NO_PERMISSIONS, PERMISSIONS } from '@models/auth.model';

export const SETTING_KEYS = {
  jwt: 'nutri_jwt',
  refresh_token: 'nutri_refresh',
  user_data: 'user_data',
} as const;

export const ROLES_NAME = {
  [PERMISSIONS.accountant]: 'NV PTTT',
  [PERMISSIONS.admin]: 'ADMIN',
  [PERMISSIONS.shop]: 'Nutriday Shop',
  [PERMISSIONS.user]: 'Người dùng',
  [PERMISSIONS.store]: 'Kho',
  [PERMISSIONS.sale_1]: 'Nhân viên sale 1',
  [PERMISSIONS.sale_2]: 'Nhân viên sale 2',
  [PERMISSIONS.nutrishop_1]: 'Nhân viên nutridayshop_1',
};

export const PERMISSIONS_REDIRECT = {
  [PERMISSIONS.accountant]: '/admin/n07',
  [PERMISSIONS.admin]: '/admin/n03',
  [PERMISSIONS.shop]: '/user/n08',
  [PERMISSIONS.user]: '/user/n08',
  [PERMISSIONS.store]: '/store/n44',
  [PERMISSIONS.sale_1]: '/admin/n16/n161',
  [PERMISSIONS.sale_2]: '/admin/n03/n031',
  [PERMISSIONS.nutrishop_1]: '/admin/n03/n038',
  [NO_PERMISSIONS]: '/auth/n01',
};
